// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__QUmxW","head":"Table_head__3jP0n","col":"Table_col__1X_sp"};